// extracted by mini-css-extract-plugin
export var button = "_5s-0";
export var icon = "_5s-1";